<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">
        
        <div class="flex flex-wrap items-center justify-between">
          <!-- <vx-input-group class="mb-base mr-3">
            <vs-input v-model="mailTo" placeholder="Email" />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button type="border" @click="mailTo = ''" class="whitespace-no-wrap">Send Invoice</vs-button>
              </div>
            </template>
          </vx-input-group> -->
        
          <div class="flex items-center">
            <vs-button v-if="link" target="_blank" :href="link" class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-download">Download</vs-button>
             <!-- <vs-button @click="down=false" v-if="relatorio" class="w-full"  color="success" iconPack="feather"
            icon="icon-download" target="_blank" :href="relatorio">Download</vs-button> -->
            <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-printer" @click="gerar">Imprimir</vs-button>
            <vs-button v-if="ver==false"  color="success" class="mb-base mr-3" icon-pack="feather" icon="icon icon-edit"  @click="ver=true">Editar</vs-button>
            <vs-button v-if="ver==true" color="gray" class="mb-base mr-3" icon-pack="feather"  icon="icon icon-eye" @click="ver=false">Visualizar</vs-button>
          </div>
        </div>

        <vx-card id="invoice-container">

            <!-- INVOICE METADATA -->
            <div class="vx-row leading-loose p-base">
                <!-- <div class="vx-col w-full md:w-1/2 mt-base">
                    <img src="@/assets/images/logo/logo.png" alt="vuexy-logo">
                </div> -->
                <!-- <div class="vx-col w-full md:w-1/2 text-right">
                    <h1>Invoice</h1>
                    <div class="invoice__invoice-detail mt-6">
                        <h6>INVOICE NO.</h6>
                        <p>{{ invoiceDetails.invoiceNo }}</p>

                        <h6 class="mt-4">INVOICE DATE</h6>
                        <p>{{ invoiceDetails.invoiceDate | date(true) }}</p>
                    </div>
                </div> -->
                <div class="vx-col w-full md:w-1/2 mt-12">
                   
                    <h2>{{employee.code}}</h2>
                    <div class="invoice__recipient-info my-4">
                        <p>
                          <span class="mr-8">NOME: <span class="font-semibold">{{user.name}} {{user.surname}}</span></span>
                    
                        </p>
                        <p><span class="mr-8">FUNÇÃO: <span class="font-semibold"> {{employee.position.name}} </span></span></p>
                       
                    </div>
                    <!-- <div class="invoice__recipient-contact ">
                        <p class="flex items-center">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ recipientDetails.mailId }}</span>
                        </p>
                        <p class="flex items-center">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ recipientDetails.mobile }}</span>
                        </p>
                    </div> -->
                </div>
                <div class="vx-col w-full md:w-1/2 mt-base text-right mt-12">
                    <h2>Informação salarial</h2>
                    <div class="invoice__company-info mt-8 my-4">
                         <p><span>SALÁRIO BASE: <span class="font-semibold"> {{payroll.salary}} .MT</span></span></p>
                        <p><span>SALÁRIO BRUTO: <span class="font-semibold"> {{payrolls.grosspay}} .MT</span></span></p>
                        <!-- <p><span>SALARIO LIQUIDO: <span class="font-semibold"> {{payrolls.netpay}} .MT</span></span></p> -->
                    </div>
                    <!-- <div class="invoice__compaeny-contact">
                        <p class="flex items-center justify-end">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ companyDetails.mailId }}</span>
                        </p>
                        <p class="flex items-center justify-end">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ companyDetails.mobile }}</span>
                        </p>
                    </div> -->

                </div>
            </div>

            <!-- INVOICE CONTENT -->
            <div class="p-base">
            
                <!-- INVOICE TASKS TABLE -->
<vs-table stripe hoverFlat :data="dedutions">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th>DEDUÇÃO</vs-th>
                        <vs-th>ABREVIAÇÃO</vs-th>
                        <!-- <vs-th>DESCRIÇÃO</vs-th> -->
                        <vs-th>VALOR</vs-th>
                        <vs-th v-if="ver==false"></vs-th>
                        <vs-th v-if="ver==true"></vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td :data="data[index].name">{{ data[index].name }}</vs-td>
                            <vs-td :data="data[index].abbreviation">{{ data[index].abbreviation }}</vs-td>
                            <!-- <vs-td :data="data[index].description">{{ data[index].description }} </vs-td> -->
                            <vs-td :data="data[index].pivot">{{ data[index].pivot.amount }} MT.</vs-td>
                              <vs-td><vs-button disabled="data[index].company_id=''" v-if="ver==true" color="success"  type="border" size="small" iconPack="feather"
            icon="icon-edit" @click="popupOpenDeducoes(tr)"></vs-button></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
<vs-table stripe hoverFlat :data="remunerations">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th>REMUNERAÇÃO</vs-th>
                        <vs-th>ABREVIAÇÃO</vs-th>
                        <!-- <vs-th>DESCRIÇÃO</vs-th> -->
                        <vs-th>VALOR</vs-th>
                         <vs-th v-if="ver==false"></vs-th>
                        <vs-th v-if="ver==true"></vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td :data="data[index].name">{{ data[index].name }}</vs-td>
                            <vs-td :data="data[index].abbreviation">{{ data[index].abbreviation }}</vs-td>
                            <!-- <vs-td :data="data[index].description">{{ data[index].description }} </vs-td> -->
                            <vs-td :data="data[index].pivot">{{ data[index].pivot.amount }} MT.</vs-td>
                              <vs-td><vs-button v-if="ver==true" color="success"  type="border" size="small" iconPack="feather"
            icon="icon-edit" @click="popupOpenRemuneracoes(tr)"></vs-button></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

              
<vs-table stripe hoverFlat :data="discounts">
                    <!-- HEADER -->
                    <template slot="thead">
                        <vs-th>DESCONTO</vs-th>
                        <vs-th>ABREVIAÇÃO</vs-th>
                        <!-- <vs-th>DESCRIÇÃO</vs-th> -->
                        <vs-th>VALOR</vs-th>
                        <vs-th v-if="ver==false"></vs-th>
                        <vs-th v-if="ver==true"></vs-th>
                    </template>

                    <!-- DATA -->
                    <template slot-scope="{data}">
                        <vs-tr v-for="(tr, index) in data" :key="index">
                            <vs-td :data="data[index].name">{{ data[index].name }}</vs-td>
                            <vs-td :data="data[index].abbreviation">{{ data[index].abbreviation }}</vs-td>
                            <!-- <vs-td :data="data[index].description">{{ data[index].description }} </vs-td> -->
                            <vs-td :data="data[index].pivot">{{ data[index].pivot.amount }} MT.</vs-td>
                            <vs-td><vs-button v-if="ver==true" color="success"  type="border" size="small" iconPack="feather"
            icon="icon-edit"></vs-button></vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <!-- INVOICE SUMMARY TABLE -->
                <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="invoiceData">
                  

   <vs-tr>
                        <th>TOTAL DE HORAS EXTRAS</th>
                        <td>{{ payroll.overtime }} </td>
                    </vs-tr>
                      <vs-tr>
                        <th>TOTAL DE FALTAS</th>
                        <td>{{ payroll.absences }} </td>
                    </vs-tr>
                    <vs-tr>
                        <th>DESCONTO POR FALTA</th>
                        <td>{{ payroll.overtime }} .MT</td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th>TOTAL DE REMUNERAÇÕES</vs-th>
                        <vs-td>{{ totalRemuneration}} MT.</vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th>TOTAL DE DESCONTOS</vs-th>
                        <vs-td>{{ totalDiscounts}} MT.</vs-td>
                    </vs-tr>
                    <vs-tr>
                        <th>TOTAL DE DEDUÇÕES</th>
                        <td>{{ totalDedutions }} MT.</td>
                    </vs-tr>
  

<vs-tr>

  
                        <th>SALÁRIO LIQUIDO</th>
                        <td>{{ payrolls.netpay }} MT.</td>

                    </vs-tr>
                    
                    
                </vs-table>
            </div>

            <!-- INVOICE FOOTER -->
            <!-- <div class="invoice__footer text-right p-base">
                <p class="mb-4">Faça o processamento usando os dados bancarios abaixo. Por favor, inclua o número da fatura no seu cheque</p>
                <p>
                    <span class="mr-8">BANCO: <span class="font-semibold">Millenium BIM</span></span>
                    <span class="mr-8">NUMERO DE CONTA: <span class="font-semibold"> 36916785 </span></span>
                    <span>NIB: <span class="font-semibold"> 11010281071110281 </span></span>

                    
                </p>
            </div> -->

            
<vs-popup class="holamundo" :title="'Actualizar '+deducao.name" :active.sync="popupEditDeducao">
     <div class="vx-row">
         <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Montante (MT)</label>
      <vs-input class="w-full mt-2 mb-5"  type="number" v-model="deducao.pivot.amount"  v-validate="'required|alpha_spaces'"
                />
        </div>

     
 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="editData">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>

    <vs-popup class="holamundo" :title="'Actualizar '+remuneracao.name" :active.sync="popupEditRemuneracao">
     <div class="vx-row">
         <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Montante (MT)</label>
      <vs-input class="w-full mt-2 mb-5"  type="number" v-model="remuneracao.pivot.amount"   v-validate="'required|alpha_spaces'"
                />
        </div>

     
 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="editData">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>
        </vx-card>
    </div>
</template>

<script>
import http from "../../../../../http-common";
export default{
    data() {
        return {
          ver:false,
          deducao:{
            pivot:{amount:""}
          },
remuneracao:{
            pivot:{amount:""}
          },
          
          totalRemuneration:"",
          totalDiscounts:"",
          totalDedutions:"",
          dedutions:[],
            payrolls:[],
            link:"",
            employee:[],
            user:[],
            discounts:[],
            mailTo: "",
            payroll:[],
        popupEditDeducao:false,
        popupEditRemuneracao:false,
        }
    },

 
    methods: {
      printInvoice() {
        window.print()
      },
  initialize(){
      this.getData();
 
    },

     popupOpenDeducoes(deducao){
   this.deducao=deducao,
         this.popupEditDeducao=true

          
        },

     popupOpenRemuneracoes(remuneracao){
   this.remuneracao=remuneracao,
         this.popupEditRemuneracao=true

          
        },

        
            gerar() {
       this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get(`salaries/salary-report/${this.$route.params.processamentoId}`, config)
        .then((result) => {
           this.$vs.loading.close()
          this.link = result.data
// alert("2")
        })
        .catch((error) => {
          error;
          this.$vs.loading.close()
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

          getData() {
       this.$vs.loading()
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get(`/salaries/payrolls/${this.$route.params.processamentoId}`, config)
        .then((result) => {
           this.$vs.loading.close()
          this.payrolls = result.data.SalaryDetais
          this.employee = result.data.SalaryDetais.employee
          this.user = result.data.SalaryDetais.employee.user
         this.discounts = result.data.SalaryDetais.discounts
        this.remunerations = result.data.SalaryDetais.remunerations
 this.dedutions = result.data.SalaryDetais.dedutions
this.payroll= result.data.SalaryDetais.payroll
        this.totalRemuneration= result.data.SalaryDetais.totalRemuneration
this.totalDiscounts= result.data.SalaryDetais.totalDiscounts
this.totalDedutions= result.data.SalaryDetais.totalDedutions

        
         
          
// alert("2")
        })
        .catch((error) => {
          error;
          this.$vs.loading.close()
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },
    },
    components: {},
    mounted() {
      this.$emit("setAppClasses", "invoice-page")
        this.initialize()
    }
}
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>
